import { createApp } from 'vue'
import DictionaryList from './DictionaryList.vue'

const el = '.kb-component--dictionary-list'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((DictionaryListDOM) => {
            if (DictionaryListDOM.hasAttribute('data-v-app')) return false
            const dictionary = Array.from(
                DictionaryListDOM.querySelectorAll('.kb-dictionary-list__group')
            ).map((group) => {
                return {
                    letter: group.querySelector(
                        '.kb-dictionary-list__group__letter'
                    ).textContent,
                    words: Array.from(
                        group.querySelectorAll(
                            '.kb-dictionary-list__group__word A'
                        )
                    ).map((link) => {
                        return {
                            word: link.textContent,
                            href: link.getAttribute('href')
                        }
                    })
                }
            })
            const showFilter = DictionaryListDOM.dataset.showfilter
            const component = createApp(DictionaryList, {
                dictionary,
                showFilter
            }).use(Store)
            component.mount(DictionaryListDOM)
        })
    }
}
